var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Footer'),(_vm.$store.state.stakeModal)?_c('StakeModal'):_vm._e(),(_vm.$store.state.transactionModal)?_c('TransactionModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }